import { render, staticRenderFns } from "./ayudantias.vue?vue&type=template&id=de1078f6&"
import script from "./ayudantias.component.ts?vue&type=script&lang=ts&"
export * from "./ayudantias.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports